import { render, staticRenderFns } from "./json.formatter.modal.vue?vue&type=template&id=567a85c5&scoped=true"
import script from "./json.formatter.modal.vue?vue&type=script&lang=js"
export * from "./json.formatter.modal.vue?vue&type=script&lang=js"
import style0 from "./json.formatter.modal.vue?vue&type=style&index=0&id=567a85c5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "567a85c5",
  null
  
)

export default component.exports